import { render, staticRenderFns } from "./NewsHistory.vue?vue&type=template&id=6e1921ac&scoped=true&"
import script from "./NewsHistory.vue?vue&type=script&lang=js&"
export * from "./NewsHistory.vue?vue&type=script&lang=js&"
import style0 from "./NewsHistory.vue?vue&type=style&index=0&id=6e1921ac&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1921ac",
  null
  
)

export default component.exports